<form [formGroup]="formGroup" (ngSubmit)="save()">
  <mat-dialog-content @fade-fast>
    <h4 class="section-heading">Basic Information</h4>
    <div class="row">
      <mat-form-field class="col-6">
        <mat-label>First Name</mat-label>
        <input
          matInput
          #firstNameInput
          formControlName="first_name"
          data-testid="quick-add-first-name"
        />
        <mat-error *ngIf="firstName.invalid">
          {{ nameError(firstName, 'a first name') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="col-6">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          formControlName="last_name"
          data-testid="quick-add-last-name"
        />
        <mat-error *ngIf="lastName.invalid">
          {{ nameError(lastName, 'a last name') }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col-6">
        <mat-label>Date of Birth</mat-label>
        <input
          matInput
          [matDatepicker]="datepicker"
          [max]="maxDateOfBirth"
          formControlName="date_of_birth"
          data-testid="quick-add-date-of-birth"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="datepicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
          <mat-datepicker-actions>
            <button mat-button matDatepickerCancel>Cancel</button>
            <button mat-flat-button color="primary" matDatepickerApply>
              Apply
            </button>
          </mat-datepicker-actions>
        </mat-datepicker>
        <mat-hint *ngIf="dateOfBirth.pristine || dateOfBirth.valid">
          MM/DD/YYYY
        </mat-hint>
        <mat-error *ngIf="dateOfBirth.invalid">
          {{ dateOfBirthError }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="col-6">
        <mat-label>Grade</mat-label>
        <mat-select
          formControlName="grade_display"
          placeholder="Grade"
          data-testid="quick-add-grade"
        >
          <mat-option *ngFor="let grade of grades" [value]="grade.value">
            {{ grade.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <pl-dropdown
        class="col-6"
        label="Location"
        formControlName="account_location"
        data-testid="quick-add-location"
        [options]="(locationOptions$ | async) ?? []"
      ></pl-dropdown>
      <mat-form-field class="col-6">
        <mat-label>Student ID</mat-label>
        <input
          matInput
          formControlName="external_id"
          placeholder="Student ID"
          data-testid="quick-add-student-id"
        />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      type="button"
      mat-stroked-button
      class="mr-2"
      data-testid="quick-add-back"
      (click)="back.emit()"
    >
      Back
    </button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="formGroup.invalid || saving"
      data-testid="quick-add-submit"
    >
      {{ isEditMode ? 'Save' : 'Add Student' }}
    </button>
  </mat-dialog-actions>
</form>
